const { chain, set } = require('lodash');

class SearchService {
    constructor(Restangular, categoriesService) {
        this.api = Restangular.one('Search');
        this.categoriesService = categoriesService;

        this.categories = [];
        this.searchCounts = {};
    }

    determineStateToShow(searchTerm, multisearchItems) {
        const params = { searchTerm, multisearchItems };

        if (searchTerm.toLowerCase().indexOf('recipe') > -1) {
            if (this.searchCounts.RecipeCount > 0) {
                return { name: 'shop.search.recipes', params };
            } else if (this.searchCounts.ProductCount > 0) {
                return { name: 'shop.search.products', params };
            } else if (this.searchCounts.ArticleCount > 0) {
                return { name: 'shop.search.articles', params };
            }

            return { name: 'shop.search.zero-result', params };
        }

        if (this.searchCounts.ProductCount > 0) {
            return { name: 'shop.search.products', params };
        } else if (this.searchCounts.RecipeCount > 0) {
            return { name: 'shop.search.recipes', params };
        } else if (this.searchCounts.ArticleCount > 0) {
            return { name: 'shop.search.articles', params };
        }

        return { name: 'shop.search.zero-result', params };
    }

    getSearchSuggestion(searchTerm) {
        return this.api.one('suggestion').get({
            Key: searchTerm,
        });
    }

    getSearchCounts(searchTerm) {
        this.searchCounts = { loadingCount: true };

        return this.api.one('count').get({
            SearchTerm: searchTerm,
        }).then((data) => {
            this.searchCounts = data.SearchCount;
        }).finally(() => {
            this.searchCounts.loadingCount = false;
        });
    }

    getCategoriesFromAggregation(aggregations) {
        if (!aggregations) return [];

        return chain(aggregations)
            .find({ Name: 'Category' })
            .get('Results', [])
            .map(r => set(this.categoriesService.getById(r.Term), 'ProductCount', r.Count))
            .filter(r => r && r.NodeLevel === 1 && r.IsSpecial === false)
            .value();
    }

    doSearch(searchTerm, pageSize, pageNumber, sortType, isSpecial, filters) {
        return this.api.post('products', {
            SearchTerm: searchTerm,
            PageSize: pageSize,
            PageNumber: pageNumber,
            SortType: sortType,
            IsSpecial: isSpecial,
            Filters: filters ? filters.filters : [],
        }).then((data) => {
            this.categories = this.getCategoriesFromAggregation(data.Aggregations);

            return {
                items: data.Products,
                totalRecordCount: data.SearchResultsCount || 0,
            };
        });
    }

    doSearchSpecials(searchTerm, pageSize, pageNumber, sortType, filters) {
        return this.api.post('specials', {
            SearchTerm: searchTerm,
            PageSize: pageSize,
            PageNumber: pageNumber,
            SortType: sortType,
            Filters: filters ? filters.filters : [],
        }).then((data) => {
            this.categories = this.getCategoriesFromAggregation(data.Aggregations);

            return {
                items: data.Products,
                totalRecordCount: data.SearchResultsCount || 0,
            };
        });
    }

    doSearchRecipes(searchTerm, pageSize, pageNumber, sortType) {
        return this.api.one('recipes').get({
            SearchTerm: searchTerm,
            PageSize: pageSize,
            PageNumber: pageNumber,
            SortType: sortType,
        }).then(data => ({
            items: data.Recipes,
            totalRecordCount: data.SearchResultsCount || 0,
        }));
    }

    doSearchArticles(searchTerm, pageSize, pageNumber) {
        return this.api.one('articles').get({
            SearchTerm: searchTerm,
            PageSize: pageSize,
            PageNumber: pageNumber,
        }).then(data => ({
            items: data.Cards,
            totalRecordCount: data.SearchResultsCount || 0,
        }));
    }
}

SearchService.$inject = ['Restangular', 'CategoriesService'];

module.exports = { SearchService };



// WEBPACK FOOTER //
// ./src/search/search.service.js